import React, { Component } from 'react';
import { Table, DatePicker, Input, Radio, Select, InputNumber } from 'antd';
import moment from 'moment';

const RadioGroup = Radio.Group;

class EditableCell extends Component {
    handleInputChange = (e) => {
        this.props.onChange(e.target.value);
    }

    handleDateChange = (date, dateString) => {
        this.props.onChange(dateString);
    }

    handleSelectChange = (val) => {
        this.props.onChange(val);
    }

    handleInputNumberChange = (val) => {
        this.props.onChange(val);
    }

    handleRadioChange = (e) => {
        this.props.onChange(e.target.value);
    }

    getContent = () => {
        const { type, value = "", typeProperty } = this.props;
        const { disabledDate = function () { } } = typeProperty || {};
        const { list = [] } = typeProperty || {};
        if(type === 'text'){
            return(
                    <span>{value}</span>
            )
        } else if (type === 'input') {
            return (
                <Input
                    value={value}
                    placeholder='请输入'
                    style={{ width: '100%' }}
                    onChange={this.handleInputChange}
                />
            )
        } else if (type === 'inputNumber') {
            const { precision, min } = typeProperty;
            return (
                <InputNumber
                    value={value}
                    style={{ width: '100%' }}
                    placeholder={"请输入"}
                    precision={precision}
                    min={min}
                    onChange={this.handleInputNumberChange}
                />
            )
        } else if (type === 'datePicker') {
            return (
                <DatePicker
                    placeholder='请选择'
                    style={{ width: '100%' }}
                    disabledDate={disabledDate}
                    value={value ? moment(value) : null}
                    onChange={this.handleDateChange}
                />
            )
        } else if (type === 'select') {
            return (
                // value == '-' ? '-' :
                <Select
                    placeholder='请选择'
                    style={{ width: '100%' }}
                    value={String(value === null ? "" : value)}
                    onChange={this.handleSelectChange}
                >
                    {(list || []).map(i =>
                        <Option key={i.value}>
                            <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{i.label}</span>
                        </Option>
                    )}
                </Select>
            )
        } else if (type === 'radio') {
            return (
                <RadioGroup
                    style={{ width: '100%' }}
                    value={value}
                    onChange={this.handleRadioChange}
                >
                    { (list || []).map(i => <Radio key={i.value} value={i.value}>{i.label}</Radio>) }
                </RadioGroup>
            )
        } else {
            return null;
        }
    }

    render() {
        return this.getContent();
    }
}

class VisitEditableTable extends Component {

    state = {
        canEdit: false,
        data: [],
        selectIndex: -1
    }

    componentDidMount() {
        const { dataSource } = this.props;
        this.setState({
            data: dataSource
        })
    }
    handleUpdate = (index) => {
        this.setState({ canEdit: true, selectIndex: index });
    }


    hide = () => {
        this.setState({ canEdit: false });
    }

    can = () => {
        this.setState({ canEdit: true });
    }


    handleChange = (value, key, index) => {
        const { data } = this.state;
        const target = data[index];
        target[key] = value;

        //如果key是isPk
        if (key === 'isPk' && value === '1') {
            target['visitFrequency'] = null;
        }
        this.setState({
            data
        })
    }

    save = (record) => {
        this.props.save(record);
        // this.setState({ canEdit: false, selectIndex: -1 })
    }

    saveSuccess = () => {
        this.setState({ canEdit: false, selectIndex: -1 })
    }

    getselectStr = (list, val, unit) => {
        const text = ((list || []).filter(item => item.value == val)[0] || {}).label;
        return (text == null || text == undefined ? '-' : (unit == null || text == undefined ? text : text + unit));
    }

    getColumns = () => {
        const { columns, isTomour } = this.props;
        const { canEdit, selectIndex } = this.state;
        const result = [];
        columns.forEach(column => {
            const { name, key, type, typeProperty, rules } = column;
            const { style, editable = true, list = [], unit, isTomour } = typeProperty || {};
            const { width } = style || {};
            const { display = true } = rules || {};
            if (display) {
                result.push({
                    title: name,
                    dataIndex: key,
                    key,
                    width,
                    render: (text, record, index) => {


                        const edit = editable && canEdit && (selectIndex == index);
                        //是否电话访视
                        const isTel = record.planVisitTypeId == 18 && key == 'isPk';
                        const pk = record.isPk == 1 && key == 'visitFrequency';

                        const setttingPk = !record.pkEdit && key == 'planPkAmount' && !isTomour
                        const canEditUnplannedVisitSubjectAmount = key == 'unplannedVisitSubjectAmount' ? record.haveUnplannedVisitConfigType : true;
                        return (
                            edit && !isTel && !pk && !setttingPk && canEditUnplannedVisitSubjectAmount ?
                                <EditableCell
                                    type={type}
                                    value={text}
                                    typeProperty={typeProperty}
                                    onChange={value => this.handleChange(value, key, index, type)}
                                />
                                :
                                (type == 'select' || type == 'radio') ? this.getselectStr(list, text, unit) : (text == null || text == undefined ? '-' : (unit == null || text == undefined ? text : text + unit))
                        )
                    }
                })
            }
        });

        if (isTomour == null || isTomour) {
            result.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 60,
                render: (text, record, index) => {

                    const { isCircularVisit, visitConfigName, configCode } = record;
                    const isQuit = visitConfigName === '提前结束访视'

                    const { edit } = this.props;

                    return (
                        //只有
                        (edit || (isCircularVisit != null && isCircularVisit == 1 && configCode!='endOfTreatmentVisit')) && !isQuit ?
                            !(canEdit && (selectIndex == '' || selectIndex == index)) ?
                                <a onClick={() => this.handleUpdate(index)}>修改</a>
                                :
                                <a onClick={() => this.save(record)}>保存</a>
                            : '-'
                    )
                }
            });

        }

        return result;
    }

    // 重新计算key值，防止重复
    getDataSource = () => {
        const { data } = this.state;
        const data_temp = (data || []).map((item, index) => {
            return {
                key: index,
                ...item,
            };
        });
        return data_temp;
    }

    computeWidth = (list) => {
        let w = 0;
        list.forEach(item => {
            const { width, children } = item;
            if (children && Array.isArray(children)) {
                w += this.computeWidth(children);
            } else {
                w += width;
            }
        });
        return w;
    }

    render() {
        const { scrollY } = this.props;
        const { selectIndex } = this.state;
        const columns = this.getColumns();
        let scrollX = this.computeWidth(columns);
        // 列表字段的width没设时，scrollX为NaN，此时默认不能左右滚动
        if (scrollX !== scrollX) {
            scrollX = false;
        } else {
            scrollX += scrollY > 0 ? 0 : 0;
        }
        return (
            <div>
                <Table
                    bordered
                    columns={columns}
                    dataSource={this.getDataSource()}
                    scroll={{ x: scrollX }}
                    pagination={false}
                />
            </div>
        );
    }
}

export default VisitEditableTable;


// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/VisitEditableTable.js